import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { ApexOptions } from 'apexcharts';
import React, { useState } from 'react';
import ReactApexcharts from 'src/@core/components/react-apexcharts';

interface DailyEngagementData {
    date: string;
    value: number;
    name: string;
}

interface EngagementChartProps {
    data: DailyEngagementData[];
}

const formatXAxis = (tickItem: string) => {
    const date = new Date(tickItem);
    return `${date.getDate()}/${date.toLocaleString('default', { month: 'short' })}`;
};

const EngagementChart: React.FC<EngagementChartProps> = ({ data }) => {
    const [selectedMetric, setSelectedMetric] = useState<string>(data[0]?.name || '');

    const filteredData = data.filter(d => d.name === selectedMetric);
    const distinctMetrics = Array.from(new Set(data.map(d => d.name)));

    const options: ApexOptions = {
        chart: {
            toolbar: { show: false }
        },
        plotOptions: {
            bar: {
                borderRadius: 8,
                distributed: true,
                columnWidth: '51%',
                endingShape: 'rounded',
                startingShape: 'rounded'
            }
        },
        legend: { show: false },
        dataLabels: { enabled: false },
        colors: ['#26C6F9'],
        xaxis: {
            categories: filteredData.map(d => formatXAxis(d.date)),
            labels: { style: { colors: '#A0AEC0' } }
        },
        yaxis: {
            show: true,
            labels: {
                formatter: (val) => val.toFixed(0)
            }
        },
        grid: { show: false },
        tooltip: {
            y: {
                formatter: (val) => `${val}`
            }
        }
    };

    return (
        <Card sx={{ maxWidth: '90%', margin: '0 auto', mt: 2, mb: 2 }}>
            <CardHeader
                title='Insights Chart'
                action={
                    <Select
                        label=' '
                        value={selectedMetric}
                        onChange={(e) => setSelectedMetric(e.target.value as string)}
                        variant="outlined"
                        style={{ marginBottom: '20px', marginTop: '10px', height: '40px', padding: '0' }}
                    >
                        {distinctMetrics.map(metric => (
                            <MenuItem key={metric} value={metric}>
                                {metric}
                            </MenuItem>
                        ))}
                    </Select>
                }
            />
            <CardContent>
                <ReactApexcharts type='bar' height={300} options={options} series={[{ data: filteredData.map(d => d.value) }]} />
            </CardContent>
        </Card>
    );
}

export default EngagementChart;
